"use strict";

var _interopRequireWildcard = require("/codebuild/output/src3029718028/src/node_modules/@babel/runtime/helpers/interopRequireWildcard.js").default;
var _interopRequireDefault = require("/codebuild/output/src3029718028/src/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _createForOfIteratorHelper2 = _interopRequireDefault(require("/codebuild/output/src3029718028/src/node_modules/@babel/runtime/helpers/createForOfIteratorHelper.js"));
require("core-js/modules/es.array.concat.js");
require("core-js/modules/es.array.find.js");
require("core-js/modules/es.array.map.js");
require("core-js/modules/es.array.push.js");
require("core-js/modules/es.function.name.js");
require("core-js/modules/es.iterator.constructor.js");
require("core-js/modules/es.iterator.find.js");
require("core-js/modules/es.iterator.map.js");
require("core-js/modules/es.number.constructor.js");
require("core-js/modules/es.number.to-fixed.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.string.trim.js");
var _log = require("@/utils/log");
var _cookie = require("@/utils/cookie");
var _organizations = require("@/api/organizations");
var Constants = _interopRequireWildcard(require("@lifehikes/lh-js-common-lib"));
var _subscriptions = require("@/api/subscriptions");
var _utils = require("@/utils");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'SubscriptionCreate',
  data: function data() {
    return {
      Constants: Constants,
      loggedInUserTenants: [],
      fullscreenloading: false,
      dialogLoopVisible: false,
      loopTableLoading: false,
      dialogCoachVisible: false,
      coachTableLoading: false,
      organizations: [],
      loopList: [],
      loopTotal: 0,
      loopQuery: {
        page: 1,
        limit: 5,
        q: undefined
      },
      coachList: [],
      coachTotal: 0,
      coachQuery: {
        page: 1,
        limit: 5,
        q: undefined
      },
      form: {
        id: '',
        tenant: Constants.TENANT_LIFEHIKES,
        organization: '',
        title: '',
        startDate: '',
        endDate: '',
        status: 'Published',
        loops: [],
        coaches: [],
        sessionsPerUser: 1,
        overallQuota: 0,
        expiryDate: '',
        performance: {
          checkinPassingRate: 80,
          minimumStepCount: 0
        }
      }
    };
  },
  created: function created() {
    this.getOrganizationsList();
    this.getLoggedInUserTenants();
    this.loadSubscription();
  },
  methods: {
    getTenantLabel: _utils.getTenantLabel,
    getLoggedInUserTenants: function getLoggedInUserTenants() {
      if (this.$store.getters.userMetadata && this.$store.getters.userMetadata.tenants) {
        this.loggedInUserTenants = this.$store.getters.userMetadata.tenants;
      } else {
        this.loggedInUserTenants = [Constants.TENANT_LIFEHIKES, Constants.TENANT_LIFEHIKES_FOUNDATION];
      }
    },
    getOrganizationsList: function getOrganizationsList() {
      var _this = this;
      var token = (0, _cookie.getCookie)('ACCESS_TOKEN');
      (0, _organizations.getAllOrganizations)(token).then(function (response) {
        if (response.data && response.data.rows) {
          _this.organizations = response.data.rows.map(function (org) {
            return {
              id: org.id,
              name: org.name
            };
          });
        }
      }).catch(function (error) {
        (0, _log.showDebugLog)('getAllOrganizations-api-error', error);
      });
    },
    loadSubscription: function loadSubscription() {
      if (this.loggedInUserTenants && this.loggedInUserTenants.length > 0) {
        this.form.tenant = this.loggedInUserTenants[0];
      } else {
        this.form.tenant = Constants.TENANT_LIFEHIKES;
      }
      this.form.expiryDate = '';
    },
    doSave: function doSave() {
      var _this2 = this;
      if (!this.form.title) {
        (0, _log.displayPopupMessage)('Subscription Title is required.', 'error');
        return;
      }
      if (!this.form.startDate) {
        (0, _log.displayPopupMessage)('Start date is required.', 'error');
        return;
      }
      if (!this.form.endDate) {
        (0, _log.displayPopupMessage)('End date is required.', 'error');
        return;
      }
      if (new Date(this.form.endDate) < new Date(this.form.startDate)) {
        (0, _log.displayPopupMessage)('End date cannot be earlier than start date.', 'error');
        return;
      }

      // Check that all coaches have a Calendly link
      var _iterator = (0, _createForOfIteratorHelper2.default)(this.form.coaches),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var coach = _step.value;
          if (!coach.calendlyLink || !coach.calendlyLink.trim()) {
            (0, _log.displayPopupMessage)("Calendly Event Type Link is required for coach ".concat(coach.givenName, " ").concat(coach.familyName, "."), 'error');
            return;
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      var token = (0, _cookie.getCookie)('ACCESS_TOKEN');
      if (token) {
        this.fullscreenloading = true;
        var org = this.organizations.find(function (o) {
          return o.name === _this2.form.organization;
        });
        var organizationId = org ? org.id : '';
        var payload = {
          metadata: {
            tenant: this.form.tenant
          },
          organizationId: organizationId,
          title: this.form.title,
          startDate: this.form.startDate ? new Date(this.form.startDate + 'T00:00:00.000Z').toISOString() : null,
          endDate: this.form.endDate ? new Date(this.form.endDate + 'T23:59:59.000Z').toISOString() : null,
          relatedPrograms: this.form.loops.map(function (loop) {
            return {
              programType: 'Loop',
              programId: loop.id
            };
          }),
          userPerformance: {
            checkinPassingRate: this.form.performance && this.form.performance.checkinPassingRate !== null && this.form.performance.checkinPassingRate !== undefined ? Number((Number(this.form.performance.checkinPassingRate) / 100).toFixed(4)) : 0.8,
            minimumStepCount: this.form.performance && this.form.performance.minimumStepCount !== null && this.form.performance.minimumStepCount !== undefined ? Number(this.form.performance.minimumStepCount) : 0
          },
          individualCoaching: {
            maxSessionsPerUser: this.form.sessionsPerUser,
            overallSessionQuota: this.form.overallQuota,
            bookingExpiry: this.form.expiryDate || null
          },
          coaches: this.form.coaches.map(function (coach) {
            return {
              userUuid: coach.uuid,
              calendlyEventTypeLinkWithSlug: coach.calendlyLink,
              isEnabled: coach.enabled
            };
          })
        };
        (0, _subscriptions.createSubscription)(token, payload).then(function (response) {
          _this2.fullscreenloading = false;
          (0, _log.displayPopupMessage)('Subscription created successfully.', 'success');
          _this2.goEdit(response.data.id);
        }).catch(function (error) {
          (0, _log.showDebugLog)('createSubscription-api-error', error);
          _this2.fullscreenloading = false;
          (0, _log.displayPopupMessage)('Failed to create subscription. ' + (error.message || ''), 'error');
        });
      }
    },
    goEdit: function goEdit(id) {
      var _this3 = this;
      this.$store.dispatch('tagsView/delView', this.$route).then(function () {
        _this3.$router.push({
          path: '/subscriptions/edit/' + id
        });
      });
    },
    goBack: function goBack() {
      var _this4 = this;
      this.$store.dispatch('tagsView/delView', this.$route).then(function () {
        _this4.$router.push({
          path: '/subscriptions/index'
        });
      });
    }
  }
};